<template>
    <div class="flex flex-direction">
        <div class="basic-editor">
            <div class="basic-editor__toolbar"></div>
            <div class="basic-editor__editable-container">
                <div class="basic-editor__editable-content-container">
                    <div class="basic-editor__editable">
                    </div>
                </div>
            </div>
        </div>
<!--        <ckeditor v-model="content" :editor="editor" @change="inputChange" @ready="onReady"></ckeditor>-->
    </div>
</template>

<script>

import DecoupledEditor from '@ckeditor/ckeditor5-build-decoupled-document';
import {BASE_URL, ckEditConfig} from "@/config";
// import CKEditor from "@ckeditor/ckeditor5-vue2";

export default {
    name: "CkBasicEditor",
    components: {
        // Use the <ckeditor> component in this view.
        // ckeditor: CKEditor.component
    },
    data() {
        return {
            editor: '',
            editorConfig: ckEditConfig(),
        }
    },
    props: {
        content: {
            type: String,
            default: ''
        },
    },
    computed: {
        token() {
            return this.$store.state.token;
        },
    },
    mounted() {
        this.init()
    },
    methods: {
        init() {
            DecoupledEditor
                .create(document.querySelector('.basic-editor__editable'), {
                        simpleUpload: {
                            uploadUrl: `${BASE_URL}api/Common/editor_img`,
                            withCredentials: false
                        },
                        fontFamily: {
                            options: [
                                '楷体,楷体_GB2312, Kai',
                                '微软雅黑,Microsoft YaHei',
                                '黑体, Hei',
                                '隶书, Li',
                            ]
                        },
                        fontSize: {
                            options: [10, 12, 14, 'default', 18, 20, 22],
                            supportAllValues: true
                        },
                        image: {
                            styles: [
                                'alignCenter',
                                'alignLeft',
                                'alignRight'
                            ],
                            resizeOptions: [
                                {
                                    name: 'resizeImage:original',
                                    label: '默认',
                                    value: null
                                },
                                {
                                    name: 'resizeImage:50',
                                    label: '50%',
                                    value: '50'
                                },
                                {
                                    name: 'resizeImage:75',
                                    label: '75%',
                                    value: '75'
                                }
                            ],
                            toolbar: [
                                'imageTextAlternative', 'toggleImageCaption', '|',
                                'imageStyle:inline', 'imageStyle:wrapText', 'imageStyle:breakText', 'imageStyle:side', '|',
                                'resizeImage'
                            ],
                            insert: {
                                integrations: [
                                    'insertImageViaUrl'
                                ]
                            }
                        },
                        placeholder: '开始编辑',
                    }
                ).then(editor => {
                const toolbarContainer = document.querySelector('.basic-editor__toolbar');
                toolbarContainer.appendChild(editor.ui.view.toolbar.element);
                editor.model.document.on('change:data', () => {
                    //把富文本编辑器获取到的内容传出去
                    this.$emit('watchEditor', editor.getData())
                });
                editor.setData(this.content);
                window.editor = editor;
                //编辑的时候设置富文本编辑器的内容
                this.editor = editor
            }).catch(err => {
                console.error(err);
            });
        },
    },
    watch: {
        content(){
            this.editor.setData(this.content);
        }
    }
}
</script>

<style lang="scss" scoped>
.basic-editor {
    //border: 1px solid var(--ck-color-base-border);
    //border-radius: var(--ck-border-radius);

    /* Set vertical boundaries for the document editor. */
    //max-height: calc(100vh - 100px - 60px - 90px);

    /* This element is a flex container for easier rendering. */
    display: flex;
    flex-flow: column nowrap;
}

.basic-editor__toolbar {
    /* Make sure the toolbar container is always above the editable. */
    z-index: 1;

    /* Create the illusion of the toolbar floating over the editable. */
    //box-shadow: 0 0 5px hsla(0, 0%, 0%, .2);

    /* Use the CKEditor CSS variables to keep the UI consistent. */
    //border-bottom: 1px solid var(--ck-color-toolbar-border);
}

/* Adjust the look of the toolbar inside of the container. */
.basic-editor__toolbar .ck-toolbar {
    border: 0!important;
    border-radius: 0;
}

/* Make the editable container look like the inside of a native word processor app. */
.basic-editor__editable-container {
    padding: calc(2 * var(--ck-spacing-large));
    //background: var(--ck-color-base-foreground);

    /* Make it possible to scroll the "page" of the edited content. */
    //overflow-y: scroll;
}

.basic-editor__editable-content-container {
    width: 23.8cm;

    /* Keep the "page" off the boundaries of the container. */
    padding: 1cm 1cm 2cm;

    //border: 1px hsl(0, 0%, 82.7%) solid;
    //border-radius: var(--ck-border-radius);
    background: white;

    /* The "page" should cast a slight shadow (3D illusion). */
    box-shadow: 0 2px 8px 0 hsla(0, 0%, 0%, .1);

    /* Center the "page". */
    margin: 0 auto;
}


.basic-editor__editable-container .basic-editor__editable.ck-editor__editable {
    /* Set the dimensions of the "page". */
    min-height: 20cm;
    margin: 0 auto;
    padding: 5px;
}

.ck.ck-editor__editable.ck-focused:not(.ck-editor__nested-editable) {
    border: none;
    box-shadow: none;
}

/* Override the page's width in the "Examples" section which is wider. */
.main__content-wide .basic-editor__editable-container .basic-editor__editable.ck-editor__editable {
    width: 18cm;
}

/* Set the default font for the "page" of the content. */
.basic-editor .ck-content,
.basic-editor .ck-heading-dropdown .ck-list .ck-button__label {
    font: 16px/1.6 "Helvetica Neue", Helvetica, Arial, sans-serif;
}

/* Adjust the headings dropdown to host some larger heading styles. */
.basic-editor .ck-heading-dropdown .ck-list .ck-button__label {
    line-height: calc(1.7 * var(--ck-line-height-base) * var(--ck-font-size-base));
    min-width: 6em;
}

/* Scale down all heading previews because they are way too big to be presented in the UI.
Preserve the relative scale, though. */
.basic-editor .ck-heading-dropdown .ck-list .ck-heading_heading1 .ck-button__label,
.basic-editor .ck-heading-dropdown .ck-list .ck-heading_heading2 .ck-button__label {
    transform: scale(0.8);
    transform-origin: left;
}

/* Set the styles for "Heading 1". */
.basic-editor .ck-content h2,
.basic-editor .ck-heading-dropdown .ck-heading_heading1 .ck-button__label {
    font-size: 2.18em;
    font-weight: normal;
}

.basic-editor .ck-content h2 {
    line-height: 1.37em;
    padding-top: .342em;
    margin-bottom: .142em;
}

/* Set the styles for "Heading 2". */
.basic-editor .ck-content h3,
.basic-editor .ck-heading-dropdown .ck-heading_heading2 .ck-button__label {
    font-size: 1.75em;
    font-weight: normal;
    color: hsl(203, 100%, 50%);
}

.basic-editor .ck-heading-dropdown .ck-heading_heading2.ck-on .ck-button__label {
    color: var(--ck-color-list-button-on-text);
}

.basic-editor .ck-content .ck-placeholder::placeholder {
    font-size: 14px;
    color: #999;
    letter-spacing: .3px;
    line-height: 24px;
}

/* Set the styles for "Heading 2". */
.basic-editor .ck-content h3 {
    line-height: 1.86em;
    padding-top: .171em;
    margin-bottom: .357em;
}

/* Set the styles for "Heading 3". */
.basic-editor .ck-content h4,
.basic-editor .ck-heading-dropdown .ck-heading_heading3 .ck-button__label {
    font-size: 1.31em;
    font-weight: bold;
}

.basic-editor .ck-content h4 {
    line-height: 1.24em;
    padding-top: .286em;
    margin-bottom: .952em;
}

/* Make the block quoted text serif with some additional spacing. */
.basic-editor .ck-content blockquote {
    font-family: Georgia, serif;
    margin-left: calc(2 * var(--ck-spacing-large));
    margin-right: calc(2 * var(--ck-spacing-large));
}


@media only screen and (max-width: 960px) {
    /* Because on mobile 2cm paddings are to big. */
    .basic-editor__editable-container .basic-editor__editable.ck-editor__editable {
        padding: 1.5em;
    }
}

@media only screen and (max-width: 1200px) {
    .main__content-wide .basic-editor__editable-container .basic-editor__editable.ck-editor__editable {
        width: 100%;
    }
}

/* Style document editor a'ka Google Docs.*/
@media only screen and (min-width: 1360px) {
    .main .main__content.main__content-wide {
        padding-right: 0;
    }
}

@media only screen and (min-width: 1600px) {
    .main .main__content.main__content-wide {
        width: 24cm;
    }

    .main .main__content.main__content-wide .main__content-inner {
        width: auto;
        margin: 0 50px;
    }

    /* Keep "page" look based on viewport width. */
    .main__content-wide .basic-editor__editable-container .basic-editor__editable.ck-editor__editable {
        width: 60%;
    }
}

</style>